import type { SVGProps } from 'react';

export function SpiderIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19 3a1 1 0 0 1 1 1v2a1 1 0 0 1-.293.707L16.414 10h3.17l1.209-1.207a1 1 0 0 1 1.414 1.414l-1.5 1.5A1 1 0 0 1 20 12h-3.585l4.292 4.293A1 1 0 0 1 21 17v2a1 1 0 0 1-2 0v-1.585l-2.016-2.016a5 5 0 0 1-9.968 0L5 17.414V19a1 1 0 0 1-.883.993L4 20a1 1 0 0 1-1-1v-2a1 1 0 0 1 .293-.707L7.584 12H4a1 1 0 0 1-.707-.293l-1.5-1.5a1 1 0 0 1 1.414-1.414L4.415 10h3.17L4.293 6.707A1 1 0 0 1 4 6V4a1 1 0 0 1 2 0v1.585L9.025 8.61a3 3 0 0 1 5.95 0L18 5.584V4a1 1 0 0 1 .883-.993z" />
    </svg>
  );
}
